import { FilterItem } from "../filters";

export enum AneelTariffImportHistoryStatus {
  FAILED = 1,
  PARTIAL = 2,
  SUCCESS = 3,
}

export const ANEEL_TARIFF_IMPORT_STATUS_OPTIONS: FilterItem[] = [
  { value: String(AneelTariffImportHistoryStatus.SUCCESS), label: "Processado com sucesso" },
  { value: String(AneelTariffImportHistoryStatus.PARTIAL), label: "Processado parcialmente" },
  { value: String(AneelTariffImportHistoryStatus.FAILED), label: "Erro no processamento" },
];

export enum AdminAneelTariffSortField {
  CREATED_AT = "createdAt",
  EFFECTIVE_DATE = "effectiveDate",
  EXPIRATION_DATE = "expirationDate",
  NAME = "name",
}

export enum TariffModalities {
  CONVENTIONAL = 0, // tarifa convencional
  GREEN = 1, // tarifa verde
  BLUE = 2, // tarifa azul
  WHITE = 3, // tarifa branca
}

export const TARIFF_MODALITY_OPTIONS: FilterItem[] = [
  { value: String(TariffModalities.CONVENTIONAL), label: "Convencional" },
  { value: String(TariffModalities.GREEN), label: "Tarifa Verde" },
  { value: String(TariffModalities.BLUE), label: "Tarifa Azul" },
  { value: String(TariffModalities.WHITE), label: "Tarifa Branca" },
];

export enum TariffTensionSubgroups {
  A1 = 0,
  A2 = 1,
  A3 = 2,
  A3a = 3,
  A4 = 4,
  AS = 5,
  B1 = 6,
  B2 = 7,
  B3 = 8,
  B4 = 9,
  NOT_FOUND = 10,
}

export const TARIFF_TENSION_SUBGROUP_OPTIONS: FilterItem[] = [
  { value: String(TariffTensionSubgroups.A1), label: "A1" },
  { value: String(TariffTensionSubgroups.A2), label: "A2" },
  { value: String(TariffTensionSubgroups.A3), label: "A3" },
  { value: String(TariffTensionSubgroups.A3a), label: "A3a" },
  { value: String(TariffTensionSubgroups.A4), label: "A4" },
  { value: String(TariffTensionSubgroups.AS), label: "AS" },
  { value: String(TariffTensionSubgroups.B1), label: "B1" },
  { value: String(TariffTensionSubgroups.B2), label: "B2" },
  { value: String(TariffTensionSubgroups.B3), label: "B3" },
  { value: String(TariffTensionSubgroups.B4), label: "B4" },
];

export enum TariffCategories {
  NOT_APPLICABLE = 0,
  PUBLIC_LIGHTING = 1,
  RESIDENTIAL = 2,
  RURAL = 3,
}

export const TARIFF_CATEGORY_OPTIONS: FilterItem[] = [
  { value: String(TariffCategories.PUBLIC_LIGHTING), label: "Iluminação Pública" },
  { value: String(TariffCategories.RESIDENTIAL), label: "Residencial" },
  { value: String(TariffCategories.RURAL), label: "Rural" },
  { value: String(TariffCategories.NOT_APPLICABLE), label: "Não aplicável" },
];

export enum TariffSubcategories {
  NOT_APPLICABLE = 0,
  LOW_INCOME = 1,
  RURAL_ELECTRIFICATION_COOPERATIVE = 2,
  RURAL_PUBLIC_IRRIGATION_SERVICE = 3,
  PUBLIC_LIGHTING_B4A = 4,
  PUBLIC_LIGHTING_B4B = 5,
  RESIDENTIAL = 6,
}

export const TARIFF_SUBCATEGORY_OPTIONS: FilterItem[] = [
  { value: String(TariffSubcategories.LOW_INCOME), label: "Baixa Renda" },
  { value: String(TariffSubcategories.RURAL_ELECTRIFICATION_COOPERATIVE), label: "Cooperativa de Eletrificação Rural" },
  { value: String(TariffSubcategories.RURAL_PUBLIC_IRRIGATION_SERVICE), label: "Serviço Público de Irrigação Rural" },
  { value: String(TariffSubcategories.PUBLIC_LIGHTING_B4A), label: "Iluminação Pública B4a" },
  { value: String(TariffSubcategories.PUBLIC_LIGHTING_B4B), label: "Iluminação Pública B4b" },
  { value: String(TariffSubcategories.RESIDENTIAL), label: "Residencial" },
  { value: String(TariffSubcategories.NOT_APPLICABLE), label: "Não aplicável" },
];

export enum TariffPeriods {
  ON_PEAK = 0,
  OFF_PEAK = 1,
  INTERMEDIATE = 2,
  NOT_APPLICABLE = 3,
}

export const TARIFF_PERIOD_OPTIONS: FilterItem[] = [
  { value: String(TariffPeriods.ON_PEAK), label: "Ponta" },
  { value: String(TariffPeriods.OFF_PEAK), label: "Fora Ponta" },
  { value: String(TariffPeriods.INTERMEDIATE), label: "Intermediário" },
  { value: String(TariffPeriods.NOT_APPLICABLE), label: "Única" },
];

export enum TariffTypes {
  DEMAND = 0,
  CONSUMPTION = 1,
}

export const TARIFF_TYPE_OPTIONS: FilterItem[] = [
  { value: String(TariffTypes.CONSUMPTION), label: "Consumo" },
  { value: String(TariffTypes.DEMAND), label: "Demanda" },
];
